import Badge from './view'

export default Badge
